import React from "react";
import { useSubscription } from "../../context/SubscriptionContext";

const GlobalSubscriptionBanner = () => {
  const { statusText, subscription } = useSubscription();
  const status = subscription?.subscription_status;

  const statusClass =
    status === "active" || status === "trialing"
      ? "bg-green-50 text-green-800 border-green-200"
      : "bg-red-50 text-red-800 border-red-200";

  return (
    <div
      className={`w-full border rounded-xl px-6 py-4 text-base font-semibold shadow-sm ${statusClass}`}
    >
      {statusText}
    </div>
  );
};

export default GlobalSubscriptionBanner;
